import { createRouter, createWebHashHistory } from 'vue-router';


const routes = [
    {
        path: '/hub',
        beforeEnter() { location.href = process.env.VUE_APP_URL_HUB },  
        component: {}  
    },
    {
        path: '/',
        name: 'inicio',   
        meta: {},            
        component: () => import('../pages/home.vue')
    },     
      
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});


export default router;


